import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', {
  state: () => ({
    isModalOpen: false,
    _modalCount: 0,
    isHeaderVisible: false,
    completedSteps: new Set<string>(),
    totalSteps: 6,
    currentSection: '',
    isLoading: false,
    loadingText: '',
    errorModal: {
      show: false,
      title: '',
      message: '',
      description: '',
      errors: [] as string[],
      icon: '⚠️',
      buttonText: 'Got it'
    }
  }),
  getters: {
    progressPercent(state): number {
      if (state.totalSteps === 0) {
        return 0;
      }
      return (state.completedSteps.size / state.totalSteps) * 100;
    }
  },
  actions: {
    showError(options: {
      title?: string;
      message: string;
      description?: string;
      errors?: string[];
      icon?: string;
      buttonText?: string;
    }) {
      this.errorModal = {
        show: true,
        title: options.title || 'Error',
        message: options.message,
        description: options.description || '',
        errors: options.errors || [],
        icon: options.icon || '⚠️',
        buttonText: options.buttonText || 'Got it'
      };
      this.openModal();
    },
    closeError() {
      if (this.errorModal.show) {
        this.errorModal.show = false;
        this.closeModal();
      }
    },
    startLoading(text = '') {
      this.isLoading = true;
      this.loadingText = text;
      document.body.classList.add('is-loading'); // Optional: prevent scrolling or interaction on body
    },
    stopLoading() {
      this.isLoading = false;
      this.loadingText = '';
      document.body.classList.remove('is-loading');
    },
    openModal() {
      this._modalCount++
      if (this._modalCount === 1) {
        this.isModalOpen = true
        document.body.classList.add('modal-open')
        document.documentElement.classList.add('modal-open')
      }
    },
    closeModal() {
      if (this._modalCount > 0) {
        this._modalCount--
      }
      if (this._modalCount === 0) {
        this.isModalOpen = false
        document.body.classList.remove('modal-open')
        document.documentElement.classList.remove('modal-open')
      }
    },
    setCurrentSection(section: string) {
      this.currentSection = section;
    },
    toggleHeader() {
      this.isHeaderVisible = !this.isHeaderVisible;
    },
    setTotalSteps(count: number) {
      this.totalSteps = count;
    },
    completeStep(stepName: string) {
      // Reassign a new Set so Pinia's reactivity picks up the change
      this.completedSteps = new Set<string>([...this.completedSteps, stepName]);
    },
    removeStep(stepName: string) {
      if (this.completedSteps.has(stepName)) {
        const next = new Set(this.completedSteps);
        next.delete(stepName);
        this.completedSteps = next;
      }
    },
    resetProgress() {
      this.completedSteps = new Set<string>();
    }
  },
})
